import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import type { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import type { TService } from '../types/services';
import { makeAdGEvent, makeMainGEvent, pushEvent } from '../utils/analytics';

export interface IAnalyticsWriteReviewItem {
  organizationType: TOrganizationTypes;
}

type GoToOrganizationParams = {
  organizationType: TOrganizationTypes;
  organizationName: string;
};

export const sendGoToOrganizationEvent = ({ organizationType, organizationName }: GoToOrganizationParams) => {
  const organizationHelper = getOrganizationHelpers(organizationType);

  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход в карточку',
      eventLabel: `${organizationHelper.namesType.bigFirstChar}|${organizationName}`,
    }),
  );
};

export const sendGoToWriteReviewEvent = ({ organizationType }: IAnalyticsWriteReviewItem) => {
  const organizationHelper = getOrganizationHelpers(organizationType);

  pushEvent(
    makeAdGEvent({
      eventCategory: 'Отзывы',
      eventAction: 'Написать отзыв',
      eventLabel: `Клиентский рейтинг ${organizationHelper.namesType.mode9}`,
    }),
  );
};

export const sendChangeLocationEvent = (locationName: string) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: `Фильтры|Город`,
      eventLabel: locationName,
    }),
  );

export const sendChangeServiceEvent = (service: TService) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: `Фильтры|Услуга`,
      eventLabel: service.label,
    }),
  );

type GoToProductReviewsEventParams = {
  organizationName: string;
  service: TService;
  productName: string;
};

export const sendGoToProductReviewsEvent = ({
  organizationName,
  service,
  productName,
}: GoToProductReviewsEventParams) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход в отзывы',
      eventLabel: `${service.label}|${organizationName}|${productName}`,
    }),
  );

export const sendGoToOrganizationVitrinEvent = ({
  organizationName,
  service,
}: {
  organizationName: string;
  service: TService;
}) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход в витрины',
      eventLabel: `${service.label}|${organizationName}`,
    }),
  );

export const sendGoToServiceReviewsEvent = ({
  organizationName,
  service,
}: {
  organizationName: string;
  service: TService;
}) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход в отзывы',
      eventLabel: `${service.label}|${organizationName}`,
    }),
  );

export const sendOpenProductPopupEvent = ({
  organizationName,
  service,
  productName,
}: {
  organizationName: string;
  service: TService;
  productName: string;
}) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: 'Переход к оформлению заявки|Поп-ап',
      eventLabel: `${service.label}|${organizationName}|${productName}`,
    }),
  );

export const sendClickButtonInPopupEvent = ({
  organizationName,
  service,
  productName,
  buttonLabel,
}: {
  organizationName: string;
  service: TService;
  productName: string;
  buttonLabel: string;
}) =>
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Рейтинги',
      eventAction: `${buttonLabel}|Поп-ап`,
      eventLabel: `${service.label}|${organizationName}|${productName}`,
    }),
  );
